<template>
  <div>
    <v-container
      v-show="!$store.state.overlay"
      class="pb-15 page__wrapper"
      style="position: relative"
    >
      <v-btn
        icon
        style="position: absolute; top: 10px; left: 10px"
        @click="back('richmenu')"
      >
        <v-icon color="primary" style="font-size: 45px"
          >mdi-chevron-left</v-icon
        >
      </v-btn>

      <template v-if="!loading">
        <template>
          <h3 class="mt-5 mb-5">
            {{ $t('Step') }} 3 : {{ $t('Upload images') }}
            <v-btn
              v-if="templateType === 'multi'"
              small
              outlined
              class="btn-custom right"
              @click="changeToCustom"
              ><span>Custom</span>
            </v-btn>
          </h3>
          <!-- <div style="max-width:500px;" ref="setWidth"></div> -->
        </template>
        <template v-if="templateType === 'single' || templateType === 'custom'">
          <div class="form-group mt-4">
            <v-btn
              color="primary"
              class="text-none"
              rounded
              depressed
              :loading="isSelecting"
              @click="onButtonClick"
            >
              <v-icon left> mdi-cloud-upload </v-icon>
              {{ buttonText }}
              <input
                ref="uploader"
                class="d-none"
                type="file"
                accept="image/*"
                @change="previewImage"
              />
            </v-btn>
            <v-btn
              v-if="imageSingle || bgCustom"
              icon
              small
              fab
              class="ml-2 color-primary"
              @click="clearImage"
            >
              <v-icon> mdi-close</v-icon>
            </v-btn>
            <p class="mb-5">
              <small>{{
                $t(
                  '* If the background image is not selected, the background will be black.'
                )
              }}</small>
            </p>
            <!-- <v-file-input
            color="primary accent-4"
            dense
            outlined
            label="Select your files"
            prepend-icon="mdi-paperclip"
            type="file"
            accept="image/*"
            @change="previewImage"
            class="form-control-file"
            id="my-file"
          >
            <template v-slot:selection="{ index, text }">
              <v-chip v-if="index < 2" color="primary accent-4" dark label small>
                {{ text }}
              </v-chip>
            </template>
          </v-file-input> -->
          </div>
        </template>
        <template>
          <div style="text-align: -webkit-center">
            <small v-if="templateSelect.content_json.size">
              {{ $t('background image size') }}
              {{
                templateSelect.content_json.size.width +
                'x' +
                templateSelect.content_json.size.height
              }}
            </small>
            <br />
            <small class="primary--text"
              >({{ $t('total_image_size_must_not_exceed_1_mb') }})</small
            >
            <div ref="setWidth" class="setKonvaWidth mt-2"></div>
            <div
              id="templateSet"
              style="
                box-sizing: border-box;
                -moz-box-sizing: border-box;
                -webkit-box-sizing: border-box;
              "
            >
              <small
                v-if="
                  templateSelect.content_json.areas.length === 0 &&
                  templateType === 'custom'
                "
                >{{
                  $t('Click and drag on an empty area to create an action.')
                }}</small
              >
              <v-stage
                v-if="templateSelect"
                ref="stage"
                style="text-align: -webkit-center; background: #ccc"
                :class="
                  templateSelect.content_json.areas.length === 0 &&
                  templateType === 'custom'
                    ? 'mt-4'
                    : 'mt-10'
                "
                :config="{
                  width: templateSelect.content_json.size.width * scaleState,
                  height: templateSelect.content_json.size.height * scaleState,
                  scale: {
                    x: scaleState,
                    y: scaleState
                  }
                }"
                @mousedown="handleStageMouseDown"
                @touchstart="handleStageMouseDown"
                @mousemove="handleStageMouseMove"
                @mouseup="handleStageMouseUp"
              >
                <v-layer ref="layer">
                  <v-image
                    enctype="Access-Control-Allow-Origin"
                    :config="{
                      width: imageSize.width,
                      height: imageSize.height,
                      image: isImage(imageSingle) ? imageSingle : null
                    }"
                  />
                  <v-image
                    v-if="templateType === 'custom'"
                    ref="layer-bgCustom"
                    :config="{
                      width: imageSize.width,
                      height: imageSize.height,
                      image: isImage(bgCustom) ? bgCustom : null
                    }"
                  />
                  <v-rect
                    v-if="templateType === 'custom' && !isImage(bgCustom)"
                    :config="{
                      x: 0,
                      y: 0,
                      name: 'bgRect',
                      width: imageSize.width,
                      height: imageSize.height,
                      rotation: 0,
                      scaleX: 1,
                      scaleY: 1
                    }"
                    @click="setSelect(null)"
                    @touchstart="setSelect(null)"
                    @mouseenter="handleMouseEnterCrosshair"
                    @mouseleave="handleMouseLeave"
                  ></v-rect>
                  <v-rect
                    v-if="scaleState !== 1 && templateType === 'single'"
                    :config="{
                      x: 0,
                      y: 0,
                      name: 'bgRect',
                      width: templateSelect.content_json.size.width,
                      height: templateSelect.content_json.size.height,
                      rotation: 0,
                      scaleX: 1,
                      scaleY: 1
                    }"
                    @dblclick="
                      chooseImagePage(templateSelect.content_json.size)
                    "
                    @dbltap="chooseImagePage(templateSelect.content_json.size)"
                  ></v-rect>
                  <template
                    v-for="(area, index) in templateSelect.content_json.areas"
                  >
                    <v-rect
                      v-if="!bgCustom && !imageSingle"
                      :key="`rect_${index}_bg`"
                      :config="{
                        x: area.bounds.x,
                        y: area.bounds.y,
                        fill: '#ccc'
                      }"
                    />
                    <v-rect
                      v-if="scaleState !== 1"
                      :ref="area.bounds.name"
                      :key="`rect_${index}`"
                      :config="{
                        name:
                          templateType !== 'custom' ? false : area.bounds.name,
                        x: area.bounds.x,
                        y: area.bounds.y,
                        width: area.bounds.width,
                        height: area.bounds.height,
                        stroke: area.bounds.stroke,
                        strokeWidth: area.bounds.strokeWidth,
                        draggable: templateType === 'custom' ? true : false
                      }"
                      @rotateEnabled="false"
                      @dblclick="
                        templateType === 'single'
                          ? null
                          : chooseImagePage(index)
                      "
                      @dbltap="
                        templateType === 'single'
                          ? null
                          : chooseImagePage(index)
                      "
                      @dragend="
                        templateType === 'single' ? null : getDataDragend(index)
                      "
                      @click="
                        templateType === 'single' ? null : setSelect(index)
                      "
                      @touchstart="
                        templateType === 'single' ? null : setSelect(index)
                      "
                      @transformend="handleTransformEnd"
                      @dragmove="
                        templateType === 'single'
                          ? null
                          : dragCheckOver($event, index)
                      "
                      @mouseenter="
                        templateType === 'custom' ? handleMouseEnterMove : null
                      "
                      @mouseleave="
                        templateType === 'custom' ? handleMouseLeave : null
                      "
                    ></v-rect>
                    <v-image
                      v-if="templateType !== 'single' && isImage(area.image)"
                      :key="`image_${index}`"
                      :ref="area.bounds.name"
                      :config="{
                        name: area.bounds.name,
                        x: area.bounds.x,
                        y: area.bounds.y,
                        width: area.bounds.width,
                        height: area.bounds.height,
                        image: isImage(area.image) ? area.image : null,
                        draggable: templateType === 'custom' ? true : false
                      }"
                      @dblclick="
                        templateType === 'single'
                          ? null
                          : chooseImagePage(index)
                      "
                      @dbltap="
                        templateType === 'single'
                          ? null
                          : chooseImagePage(index)
                      "
                      @dragend="
                        templateType === 'single' ? null : getDataDragend(index)
                      "
                      @click="
                        templateType === 'single' ? null : setSelect(index)
                      "
                      @touchstart="
                        templateType === 'single' ? null : setSelect(index)
                      "
                      @transformend="handleTransformEnd"
                      @dragmove="
                        templateType === 'single'
                          ? null
                          : dragCheckOver($event, index)
                      "
                      @mouseenter="
                        templateType === 'custom' ? handleMouseEnterMove : null
                      "
                      @mouseleave="
                        templateType === 'custom' ? handleMouseLeave : null
                      "
                    />
                    <v-text
                      v-if="scaleState !== 1 && templateType === 'multi'"
                      :key="`text___${index}`"
                      :config="{
                        text: `${$t('Picture')} ${index + 1}`,
                        x: area.bounds.x,
                        y: area.bounds.y + 45,
                        width: area.bounds.width,
                        fontSize: 60,
                        align: 'center',
                        fill: '#FFFFFF'
                      }"
                    />
                    <v-text
                      v-if="scaleState !== 1 && templateType === 'multi'"
                      :key="`text___size___${index}`"
                      :config="{
                        text: `${area.bounds.width.toFixed(
                          0
                        )} x ${area.bounds.height.toFixed(0)}`,
                        x: area.bounds.x - 15,
                        y: area.bounds.y + area.bounds.height - 200 / 2,
                        width: area.bounds.width,
                        align: 'right',
                        fill: '#FFFFFF',
                        fontSize: 60
                      }"
                    />
                    <v-image
                      v-if="scaleState !== 1 && templateType === 'multi'"
                      :key="`image___edit${index}`"
                      :config="{
                        x: area.bounds.x + area.bounds.width / 2 - 350 / 2,
                        y: area.bounds.y + area.bounds.height / 2 - 350 / 2,
                        width: 350,
                        height: 350,
                        image: isImage(editImage) ? editImage : null
                      }"
                      @click="chooseImagePage(index)"
                      @touchstart="chooseImagePage(index)"
                      @mouseenter="handleMouseEnter"
                      @mouseleave="handleMouseLeave"
                    />
                  </template>
                  <v-image
                    v-if="scaleState !== 1 && templateType === 'single'"
                    :config="{
                      x: templateSelect.content_json.size.width / 2 - 350 / 2,
                      y: templateSelect.content_json.size.height / 2 - 350 / 2,
                      width: 350,
                      height: 350,
                      image: isImage(editImage) ? editImage : null
                    }"
                    @click="chooseImagePage(templateSelect.content_json.size)"
                    @touchstart="
                      chooseImagePage(templateSelect.content_json.size)
                    "
                    @mouseenter="handleMouseEnter"
                    @mouseleave="handleMouseLeave"
                  />
                  <v-transformer ref="transformer" :rotate-enabled="false" />
                </v-layer>
              </v-stage>
              <div class="pl-4 keyboard py-2">
                <v-icon style="font-size: 35px; float: left" color="#ffffff"
                  >mdi-keyboard</v-icon
                >
                <div
                  class="pa-1 text-center"
                  style="padding-right: 40px !important; min-height: 32px"
                >
                  <span
                    >{{ templateSelect.content_json.chatBarText }}
                    <v-icon color="#ffffff"> mdi-menu-down </v-icon>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="text-center">
            <v-btn
              v-if="templateType === 'custom'"
              text
              small
              class="br-7"
              @click="addRectangle"
              ><v-icon class="mr-2">mdi-shape-rectangle-plus</v-icon>
              {{ $t('add_frame') }}</v-btn
            >
            <v-btn
              v-if="templateType === 'custom' && layerIndex !== null"
              outlined
              fab
              small
              class="w45 br-7"
              @click="deleteRectangle(layerIndex)"
              ><v-icon>mdi-delete-outline</v-icon></v-btn
            >
            <v-btn
              v-if="templateType === 'custom' && layerIndex !== null"
              outlined
              fab
              small
              class="w45 br-7"
              @click="chooseImagePage(layerIndex)"
              ><v-icon>mdi-pencil-outline</v-icon></v-btn
            >
          </div>
        </template>
        <template>
          <v-card class="command-bar">
            <div
              v-if="innerWidth > 750"
              class="btn-sticky mt-5 pr-pl-12 sticky-left"
            >
              <v-btn
                outlined
                class="btn-custom right btn-custom-outline-color"
                :href="how_to_use_blog"
                target="blank"
                depressed
                rounded
              >
                <v-icon>mdi-help-circle</v-icon
                ><span class="ml-1"> {{ $t('How to use') }}</span>
              </v-btn>
            </div>
            <div class="btn-sticky mt-5 pr-pl-12 sticky-right">
              <v-btn
                outlined
                class="btn-back-richmenu br-7 mr-5"
                style="width: 160px"
                @click="back"
                >{{ $t('Choose template') }}</v-btn
              >
              <v-btn
                outlined
                class="btn-custom btn-next-richmenu right"
                style="width: 160px"
                :disabled="templateSelect.content_json.areas.length === 0"
                @click="goToPageSelectAction"
                ><span>{{ $t('save_and_next') }}</span>
              </v-btn>
              <div v-if="templateType === 'custom'" class="text-right">
                <small>{{ $t('* Add at least one image action.') }}</small>
              </div>
              <small v-if="templateType === 'custom'">{{
                $t(
                  '** If you press next, images will be merged and cannot edit.'
                )
              }}</small>
            </div>
          </v-card>
        </template>
      </template>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import imageSetting from '../../mixins/imageSetting'
import icon from '../../assets/image/icons/edit.png'
import configUrl from '@/config'
export default {
  components: {},
  data() {
    return {
      innerWidth: 0,
      templateType: '',
      image: null,
      bgCustom: '',
      imageSingle: '',
      imageSize: {
        width: 2500,
        height: 1686
      },
      selectedShapeName: '',
      layerIndex: null,
      hasFalseKeys: false,
      editImage: null,
      maxWidth: 0,
      scaleState: 0,
      isSelecting: false,
      nameStageMouseDown: null,
      moveUp: {},
      moveDown: {},
      // defaultImage: null,
      //   loadingImg: false,
      loading: true,
      how_to_use_blog: configUrl.how_to_use_blog
    }
  },
  async created() {
    this.innerWidth = window.innerWidth
  },
  computed: {
    ...mapGetters({
      templateSelect: 'lineRichmenuManager/getTemplateSelect',
      uploadSelectType: 'lineRichmenuManager/getUploadSelectType',
      getIdTemplate: 'lineRichmenuManager/getIdTemplate',
      groupId: 'lineRichmenuManager/getGroupId',
      Scale: 'lineRichmenuManager/getScale'
    }),

    buttonText() {
      return (this.imageSingle || this.bgCustom) && this.image
        ? this.image.name
        : this.$t('Select your background image')
    }
    // scaleState() {
    //   return this.maxWidth / this.templateSelect.content_json.size.width;
    // },
  },
  async mounted() {
    this.loading = true
    this.templateType = this.templateSelect.type
    try {
      this.$set(
        this.imageSize,
        'height',
        this.templateSelect.content_json.size.height
      )
      this.$set(
        this.imageSize,
        'width',
        this.templateSelect.content_json.size.width
      )
    } catch (error) {
      //
    }
    // if (this.templateSelect.content_json.size.width === 2500) {
    //   this.templateSelect.content_json.size.height =
    //     this.templateSelect.content_json.size.height / 7;
    //   this.templateSelect.content_json.size.width = this.templateSelect.content_json.size.width / 7;
    //   this.templateSelect.content_json.areas.map((item) => {
    //     item.bounds.height = item.bounds.height / 7;
    //     item.bounds.width = item.bounds.width / 7;
    //     item.bounds.x = item.bounds.x / 7;
    //     item.bounds.y = item.bounds.y / 7;
    //   });
    // }

    const image = new window.Image()
    image.src = icon
    image.onload = () => {
      // set image only when it is loaded
      this.editImage = image
    }

    this.hasFalseKeys = Object.keys(
      this.templateSelect.content_json.areas
    ).some((k) => this.isImage(this.templateSelect.content_json.areas[k].image))

    this.loading = false
    await this.$nextTick()
    // this.maxWidth = this.$refs.setWidth.clientWidth;
    this.scaleState =
      this.$refs.setWidth.clientWidth /
      this.templateSelect.content_json.size.width
    document.addEventListener('keydown', this.onKeydown)
    await this.$nextTick()
    if (this.templateSelect.content_json.bgImage) {
      if (typeof this.templateSelect.content_json.bgImage === 'string') {
        this.bgCustom = await this.loadImage(
          this.templateSelect.content_json.bgImage
        )
      } else {
        this.bgCustom = this.templateSelect.content_json.bgImage
        if (this.templateType === 'custom' && this.Scale) {
          var template = this._.cloneDeep(this.templateSelect)
          var scale = template.content_json.size.width / this.Scale.width

          this.$set(this.imageSize, 'height', this.Scale.height * scale)
          this.$set(this.imageSize, 'width', template.content_json.size.width)
        }
      }
    }

    if (typeof this.templateSelect.image_url === 'string') {
      this.imageSingle = await this.loadImage(this.templateSelect.image_url)
    } else {
      this.imageSingle = this.templateSelect.image_url
    }
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    onKeydown(e) {
      if ((e.keyCode == 8 || e.keyCode == 46) && this.layerIndex != null) {
        this.deleteRectangle(this.layerIndex)
      }
    },
    onButtonClick() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )

      this.$refs.uploader.click()
    },
    handleMouseEnterMove(e) {
      const stage = e.target.getStage()
      stage.container().style.cursor = 'move'
    },
    handleMouseEnterCrosshair(e) {
      const stage = e.target.getStage()
      stage.container().style.cursor = 'crosshair'
    },
    handleMouseEnter(e) {
      const stage = e.target.getStage()
      stage.container().style.cursor = 'pointer'
    },
    handleMouseLeave(e) {
      const stage = e.target.getStage()
      stage.container().style.cursor = 'default'
    },

    isImage(i) {
      return i instanceof HTMLImageElement
    },
    dragCheckOver(e, index) {
      if (e.target.attrs.x < 0) {
        this.$refs[e.target.attrs.name][0].getNode().setAttrs({
          x: 0
        })
        this.$set(e.target.attrs, 'x', 0)
      } else if (
        e.target.attrs.x >
        this.templateSelect.content_json.size.width - e.target.attrs.width
      ) {
        this.$refs[e.target.attrs.name][0].getNode().setAttrs({
          x: this.templateSelect.content_json.size.width - e.target.attrs.width
        })
        this.$set(
          e.target.attrs,
          'x',
          this.templateSelect.content_json.size.width - e.target.attrs.width
        )
      } else {
        this.templateSelect.content_json.areas[index].bounds.x =
          e.target.attrs.x
      }
      if (e.target.attrs.y < 0) {
        this.$refs[e.target.attrs.name][0].getNode().setAttrs({
          y: 0
        })
        this.$set(e.target.attrs, 'y', 0)
      } else if (
        e.target.attrs.y >
        this.templateSelect.content_json.size.height - e.target.attrs.height
      ) {
        this.$refs[e.target.attrs.name][0].getNode().setAttrs({
          y:
            this.templateSelect.content_json.size.height - e.target.attrs.height
        })
        this.$set(
          e.target.attrs,
          'y',
          this.templateSelect.content_json.size.height - e.target.attrs.height
        )
      } else {
        this.templateSelect.content_json.areas[index].bounds.y =
          e.target.attrs.y
      }
    },
    deleteRectangle(i) {
      if (this.layerIndex === i) {
        this.layerIndex = null
        this.templateSelect.content_json.areas.splice(i, 1)
      } else {
        this.templateSelect.content_json.areas.splice(i, 1)
      }
      this.$refs.transformer.getNode().nodes([])
    },
    setSelect(index) {
      this.layerIndex = index
    },
    clearImage() {
      this.$refs.uploader.value = null
      this.image = null
      this.imageSingle = null
      try {
        this.$set(
          this.imageSize,
          'height',
          this.templateSelect.content_json.size.height
        )
        this.$set(
          this.imageSize,
          'width',
          this.templateSelect.content_json.size.width
        )
      } catch (error) {
        //
      }
      this.bgCustom = null
    },
    previewImage: function (files) {
      // console.log(files);
      this.hasFalseKeys = true

      if (files.target.files[0]) {
        var reader = new FileReader()
        reader.onload = (e) => {
          const image = new window.Image()
          image.src = e.target.result
          this.image = files.target.files[0]
          image.onload = () => {
            // set image only when it is loaded
            // console.log(
            //   image.height,
            //   image.width,
            //   this.templateSelect.content_json
            // );

            var template = this._.cloneDeep(this.templateSelect)
            var scale = template.content_json.size.width / image.width
            // template.content_json.size.height = image.height * scale;

            this.$store.dispatch('lineRichmenuManager/setScaleBgImage', image)

            try {
              this.$set(this.imageSize, 'height', image.height * scale)
              this.$set(
                this.imageSize,
                'width',
                template.content_json.size.width
              )
            } catch (error) {
              //
            }

            if (this.templateSelect.type === 'single') {
              this.imageSingle = image
            } else if (this.templateSelect.type === 'custom') {
              this.bgCustom = image
              template.content_json.bgImage = image

              this.$store.dispatch(
                'lineRichmenuManager/setTemplateSelect',
                template
              )
              this.templateSelect.content_json.bgImage = image
            }
          }
        }
        // this.imageSingle = input.files[0];
        reader.readAsDataURL(files.target.files[0])
      } else {
        this.bgCustom = null
        this.imageSingle = null
      }
    },
    getDataDragend(index) {
      this.setSelect(index)
      // const icon = this.templateSelect.content_json.areas.find(
      //   (r) => r.bounds.name === e.target.attrs.name
      // );
      // icon.bounds.x = e.target.attrs.x / this.scaleState;
      // icon.bounds.y = e.target.attrs.y / this.scaleState;
      // this.$store.dispatch("lineRichmenuManager/setTemplateSelect", this.templateSelect);
    },
    async handleTransformEnd(e) {
      const icon = this.templateSelect.content_json.areas.find(
        (r) => r.bounds.name === this.selectedShapeName
      )

      if (e.target.attrs.x < 0) {
        this.$refs[e.target.attrs.name][0].getNode().setAttrs({
          x: 0
        })
        this.$set(e.target.attrs, 'x', 0)
      }

      if (e.target.attrs.y < 0) {
        this.$refs[e.target.attrs.name][0].getNode().setAttrs({
          y: 0
        })
        this.$set(e.target.attrs, 'y', 0)
      }

      const maxWidth = this.templateSelect.content_json.size.width
      const maxHeight = this.templateSelect.content_json.size.height
      const ref = this.$refs[e.target.attrs.name]

      if (!icon || !ref || ref.length === 0) return

      const refName = ref[0].getNode()

      // คำนวณขนาดใหม่โดยคำนึงถึง scale
      let oldWidth = icon.bounds.width
      let oldHeight = icon.bounds.height
      let newWidth = refName.width() * refName.scaleX()
      let newHeight = refName.height() * refName.scaleY()

      // จำกัดขนาดไม่ให้เกิน maxWidth และ maxHeight
      newWidth = Math.min(newWidth, maxWidth)
      newHeight = Math.min(newHeight, maxHeight)

      // ปรับตำแหน่งใหม่เมื่อขยายทางซ้าย
      let deltaX = (newWidth - oldWidth) / 2
      let deltaY = (newHeight - oldHeight) / 2

      // อัปเดตขนาดและตำแหน่ง
      this.$set(icon.bounds, 'width', newWidth)
      this.$set(icon.bounds, 'height', newHeight)
      this.$set(icon.bounds, 'x', e.target.x() - deltaX)
      this.$set(icon.bounds, 'y', e.target.y() - deltaY)
      icon.bounds.rotation = e.target.rotation()

      // รีเซ็ต scaleX และ scaleY เป็น 1
      refName.setAttrs({
        width: newWidth,
        scaleX: 1,
        height: newHeight,
        scaleY: 1
      })

      this.$store.dispatch(
        'lineRichmenuManager/setTemplateSelect',
        this.templateSelect
      )
    },
    handleStageMouseUp(e) {
      if (this.nameStageMouseDown) {
        this.moveUp = { x: e.evt.layerX, y: e.evt.layerY }
        var x = this.moveDown.x / this.scaleState
        var y = this.moveDown.y / this.scaleState
        var x2 = this.moveUp.x / this.scaleState
        var y2 = this.moveUp.y / this.scaleState
        var width =
          this.moveUp.x / this.scaleState - this.moveDown.x / this.scaleState
        var height =
          this.moveUp.y / this.scaleState - this.moveDown.y / this.scaleState
        if (width < 0) {
          width = Math.abs(width)
          x = x2
        }
        if (height < 0) {
          height = Math.abs(height)
          y = y2
        }

        this.templateSelect.content_json.areas.map((reg, index) => {
          if (reg.bounds.name === this.nameStageMouseDown) {
            reg.bounds.width = width
            reg.bounds.x = x
            reg.bounds.height = height
            reg.bounds.y = y

            if (width < 100 || height < 100) {
              this.templateSelect.content_json.areas =
                this.templateSelect.content_json.areas.filter(
                  (item) => item.bounds.name !== this.nameStageMouseDown
                )
            }

            this.$nextTick(() => {
              this.layerIndex = index
            })
            this.$store.dispatch(
              'lineRichmenuManager/setTemplateSelect',
              this.templateSelect
            )
            // console.log(index);
            this.nameStageMouseDown = null
            this.selectedShapeName = reg.bounds.name
            this.updateTransformer()
          }
        })
        // const reg = this.templateSelect.content_json.areas.find(
        //   (r) => r.bounds.name === this.nameStageMouseDown
        // );
        // reg.bounds.width = width;
        // reg.bounds.x = x;
        // reg.bounds.height = height;
        // reg.bounds.y = y;
        // if (width < 200 || height < 200) {
        //   this.templateSelect.content_json.areas = this.templateSelect.content_json.areas.filter(
        //     (item) => item.bounds.name !== this.nameStageMouseDown
        //   );
        // }
        // this.$store.dispatch("lineRichmenuManager/setTemplateSelect", this.templateSelect);

        // this.nameStageMouseDown = null;
        // this.selectedShapeName = reg.bounds.name;
        // this.updateTransformer();
      }
    },
    handleStageMouseMove(e) {
      const layer = this.$refs.layer.getNode()
      if (this.nameStageMouseDown) {
        this.$refs[this.nameStageMouseDown][0].getNode().setAttrs({
          width: (e.evt.layerX - this.moveDown.x) / this.scaleState,
          x: this.moveDown.x / this.scaleState,
          height: (e.evt.layerY - this.moveDown.y) / this.scaleState,
          y: this.moveDown.y / this.scaleState
        })
        layer.batchDraw()
      }
    },
    handleStageMouseDown(e) {
      if (this.templateType === 'custom') {
        this.$nextTick(() => {
          if (
            this.$refs.transformer.getNode().nodes().length === 0 &&
            this.templateSelect.content_json.areas.length < 20
          ) {
            this.moveDown = { x: e.evt.layerX, y: e.evt.layerY }
            this.nameStageMouseDown = JSON.stringify(new Date().getTime())
            this.templateSelect.content_json.areas.push({
              bounds: {
                name: this.nameStageMouseDown,
                x: this.moveDown.x / this.scaleState,
                y: this.moveDown.y / this.scaleState,
                rotation: 0,
                width: 0,
                height: 0,
                stroke: '#FFFFFF',
                strokeWidth: 3,
                draggable: true,
                scaleX: 1,
                scaleY: 1
              },
              action: { type: 'none' },
              image: null
            })
          }
        })
      }
      // clicked on stage - clear selection
      if (e.target === e.target.getStage()) {
        this.selectedShapeName = ''
        this.updateTransformer()
        return
      }

      // clicked on transformer - do nothing
      const clickedOnTransformer =
        e.target.getParent().className === 'Transformer'
      if (clickedOnTransformer) {
        return
      }

      // find clicked icon by its name
      const name = e.target.name()
      const icon = this.templateSelect.content_json.areas.find(
        (r) => r.bounds.name === name
      )
      if (icon) {
        this.selectedShapeName = name
      } else {
        this.selectedShapeName = ''
      }
      this.updateTransformer()
    },
    updateTransformer() {
      // here we need to manually attach or detach Transformer node
      // console.log();
      const transformerNode = this.$refs.transformer.getNode()
      const stage = transformerNode.getStage()
      const { selectedShapeName } = this
      const selectedNode = stage.findOne('.' + selectedShapeName)
      // do nothing if selected node is already attached
      if (selectedNode === transformerNode.node()) {
        return
      }

      if (selectedNode) {
        // attach to another node
        transformerNode.nodes([selectedNode])
      } else {
        // remove transformer
        transformerNode.nodes([])
      }
      transformerNode.getLayer().batchDraw()
    },
    changeToCustom() {
      this.$set(this.templateSelect, 'type', 'custom')

      this.templateType = 'custom'
      this.$store.dispatch(
        'lineRichmenuManager/setTemplateSelect',
        this.templateSelect
      )
    },
    addRectangle() {
      var id = JSON.stringify(new Date().getTime())
      var gap = 30
      var filterAreas = this.templateSelect.content_json.areas
        .filter((el) => {
          return el.bounds.x % gap == 0 && el.bounds.y % gap == 0
        })
        .map((el) => {
          return el.bounds.x
        })

      var x = 0,
        y = 0
      if (filterAreas && filterAreas.length > 0) {
        let max = Math.max(...filterAreas)
        x = max + gap
        y = max + gap
      }

      this.templateSelect.content_json.areas.push({
        bounds: {
          name: id,
          x: x,
          y: y,
          rotation: 0,
          width: 1250,
          height: 843,
          stroke: '#FFFFFF',
          strokeWidth: 3,
          draggable: true,
          scaleX: 1,
          scaleY: 1
        },
        action: { type: 'none' },
        image: null
      })

      this.$nextTick(async () => {
        // console.log(e);
        this.$refs[id][0].$listeners.transformend()
      })
      // handleStageMouseDown
      // console.log(JSON.stringify(new Date().getTime()));
      // const transformerNode = this.$refs.transformer.getNode();
      // const stage = transformerNode.getStage();
      // const selectedNode = stage.findOne("." + JSON.stringify(new Date().getTime()));

      // console.log(stage);
      // this.$refs.transformer.getNode().nodes([selectedNode]);
      this.$store.dispatch(
        'lineRichmenuManager/setTemplateSelect',
        this.templateSelect
      )
    },
    // loadingImage(img) {
    //   if (typeof img !== "undefined") {
    //     const image = new window.Image();
    //     image.src = img;
    //     image.onload = () => {
    //       // set image only when it is loaded
    //       image.crossOrigin = "Anonymous";
    //       return image;
    //     };
    //     return image;
    //   }
    // },
    chooseImagePage(index) {
      this.$store.dispatch('lineRichmenuManager/setImageSelect', index)
      this.$emit('goToPage', 4)
    },
    async goToPageSelectAction() {
      var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
      this.$gtag.event('event', {
        event_category: prefix + 'Step 3 Upload images next'
        // event_label: bot.pagename + utm,
      })
      this.$store.dispatch('setOverlay', true)
      await this.mergeImage()

      if (this.getIdTemplate !== null) {
        // If already have a richmenu exist
        var templateSelect = this.templateSelect.content_json.areas.filter(
          (item) => item.bounds.height > 0
        )
        this.templateSelect.content_json.areas = templateSelect
        this.$store.dispatch(
          'lineRichmenuManager/putTemplateSelect',
          this.templateSelect
        )
      } else {
        // Create new richmenu
        this.templateSelect.package_id = this.groupId.id || null
        this.$store.dispatch(
          'lineRichmenuManager/postTemplateSelect',
          this.templateSelect
        )
      }

      this.$store.dispatch('setOverlay', false)
      this.$emit('goToPage', 5)
    },
    back(setPage) {
      if (setPage == 'richmenu') {
        const path = `/${this.currentLang}/richmenu`
        if (this.$route.path !== path) {
          this.$router.push({ path })
        }
      } else {
        this.$confirm(
          `${this.$t(
            'Pressing back button may cause your previous setting will be deleted. Do you want to continue?'
          )}`,
          this.$t('Are you sure?'),
          'question',
          {
            reverseButtons: true,
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel')
          }
        ).then(async () => {
          this.$emit('goToPage', 1)
        })
      }
    },
    mergeImage() {
      return new Promise((resolve) => {
        this.$refs.transformer.getNode().nodes([])

        this.scaleState = 1
        this.$nextTick(() => {
          // if (this.hasFalseKeys || typeof this.templateSelect.image_url !== "string") {
          var vm = this

          vm.$refs.stage.getStage().toImage({
            callback: function (img) {
              var file = imageSetting.methods.dataURItoBlob(img.src)

              imageSetting.methods.upload(file, Date.now()).then((res) => {
                vm.templateSelect.image_url = res
                vm.$store.dispatch('lineRichmenuManager/setScaleBgImage', null)
                resolve()
              })
            },
            mimeType: 'image/jpeg'
          })
          // } else {
          //   this.$store.dispatch("setOverlay", false);
          //   this.$emit("goToPage", 5);
          // }
        })
      }, this)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-btn--fab.v-size--small {
  padding: 15px;
  height: 23px;
  width: 23px;
  border: none;
  margin-right: 5px;
}
</style>
